export default "__VITE_ASSET__dpc9fWvC__"